// Status of the legal texts (terms and data usage) and the values other modules share.

// Version of the terms shown on the Terms page.
export const TERMS_VERSION = "2026-10";

/**
 * Builds the mailto link for the contact entry.
 * @param {string | undefined} email - value of FEEDBACK_EMAIL
 * @returns {string | null} `mailto:<email>`, or null when the address is empty or not an email (the entry is then omitted)
 */
export const contactMailto = (email) => {
	const trimmed = typeof email === "string" ? email.trim() : "";
	// One "@" with text on both sides, a dot in the domain, and no whitespace
	const parts = trimmed.split("@");
	const [local, domain] = parts;
	const valid = parts.length === 2 && local.length > 0 && domain.includes(".") && !/\s/.test(trimmed) && !domain.startsWith(".") && !domain.endsWith(".");
	return valid ? `mailto:${trimmed}` : null;
};
